module.exports = __webpack_public_path__ + "media/reskin-images/icon--export-purple-ba3dba6f.svg";